import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AngularSplitModule } from 'angular-split'

import { InputContainerComponent } from './input/input-container/input-container.component'
import { FileService } from './file/file.service'
import { ViewModule } from './view/view.module'
import { FilterByPipe } from './filterName.pipe'
import { ModalMessageComponent } from './modal/modal-message/modal-message.component'
import { ModalMessageService } from './modal/modal-message/modal-message.service'
import { ModalSearchComponent } from './modal/modal-search/modal-search.component'
import { ModalSearchService } from './modal/modal-search/modal-search.service'
import { InputSearchComponent } from './input/input-search/input-search.component'
import { DatepickerComponent } from './datepicker/datepicker.component'
import { TabComponent } from './tab/tab/tab.component'
import { TabsetComponent } from './tab/tabset/tabset.component'
import { CurrencyPipe } from './currency.pipe'
import { CurrencyFormatterDirective } from './currency.directive'
import { UpperCaseDirective, LowerCaseDirective } from './uppercase.directive'
import { PercentPipe } from './percent.pipe'
import { PercentFormatterDirective } from './percent.directive'
import { InputCounterComponent } from './input/input-counter/input-counter.component'
import { InputSearchService } from './input/input-search/input.search.service'
import { ExportService } from './export.invoice.service'
import { GroupByPipe } from './group.pipe'
import { FilterTabByPipe } from './filter.pipe'
import { ModalUploadFileComponent } from './modal/modal-upload-file/modal-upload-file.component'
import { FileUploadModule } from 'ng2-file-upload'
import { ModalUploadFileService } from './modal/modal-upload-file/modal-upload-file.service'

@NgModule({
    declarations: [
        ModalMessageComponent,
        ModalSearchComponent,
        ModalUploadFileComponent,
        InputContainerComponent,
        InputCounterComponent,
        InputSearchComponent,
        DatepickerComponent,
        TabComponent,
        TabsetComponent,
        FilterByPipe,
        FilterTabByPipe,
        GroupByPipe,        
        CurrencyPipe,
        CurrencyFormatterDirective,
        UpperCaseDirective,
        LowerCaseDirective,
        PercentPipe,
        PercentFormatterDirective

    ],
    imports: [
        CommonModule,
        FileUploadModule,
        AngularSplitModule.forRoot(),
        ViewModule.forRoot()
    ],
    exports: [
        CommonModule,
        FileUploadModule,
        ViewModule,
        FilterByPipe,
        FilterTabByPipe,
        ModalMessageComponent,
        ModalSearchComponent,
        ModalUploadFileComponent,
        InputContainerComponent,
        InputCounterComponent,
        InputSearchComponent,
        DatepickerComponent,
        TabComponent,
        TabsetComponent,
        CurrencyPipe,
        GroupByPipe,        
        CurrencyFormatterDirective,
        UpperCaseDirective,
        LowerCaseDirective,
        PercentPipe,
        PercentFormatterDirective

    ]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                ModalMessageService,
                ModalSearchService,
                InputSearchService,
                FileService,
                ModalUploadFileService,
                CurrencyPipe,
                CurrencyFormatterDirective,
                UpperCaseDirective,
                LowerCaseDirective,
                PercentPipe,
                PercentFormatterDirective,
                ExportService

            ]
        }
    }
}